'use client'

import { IconSearch } from '@macarongfactory/web-icons'
import { SearchField } from '@macarongfactory/web-ui'
import Link from 'next/link'

import { MycleLogoDefault } from '@/shared/assets/icons'

import { MODOOCAR_CODE, useModoocarTracking } from '../_features/modoocar'

const SearchHeader = () => {
  const { logoClick, itemClick } = useModoocarTracking()

  const trackSearchClick = () =>
    itemClick(MODOOCAR_CODE.HEADER, 'search_bar', '검색')

  return (
    <header className='sticky top-0 z-20 bg-background-surface-default'>
      <div className='flex w-full items-center gap-dimension-x2 px-dimension-x5 py-dimension-x3 lg:gap-dimension-x6'>
        <Link
          href='/modoocar/home'
          aria-label='모두의 차고 홈'
          onClick={logoClick}
          className='shrink-0 text-foreground-brand-strong'
        >
          <MycleLogoDefault fill='currentColor' width='100' height='20' />
        </Link>

        <Link
          href='/modoocar/search'
          onClick={trackSearchClick}
          className='hidden flex-1 lg:block'
        >
          <SearchField
            placeholder='제조사/모델 검색'
            className='w-full pointer-events-none'
          />
        </Link>

        <Link
          href='/modoocar/search'
          onClick={trackSearchClick}
          aria-label='차종 검색'
          className='ml-auto shrink-0 lg:hidden'
        >
          <IconSearch width={24} height={24} />
        </Link>
      </div>
    </header>
  )
}

export default SearchHeader
